// utils/parseEnrichment.ts
import type { EnrichedVulnerability } from '@/sections/threats/types';
import type { Vulnerability } from '@/types';

/**
 * Parse vulnerability enrichment data from JSON string
 */

export function parseEnrichment(vuln: Vulnerability): EnrichedVulnerability;
// eslint-disable-next-line no-redeclare
export function parseEnrichment(
  vuln: Vulnerability | undefined
): EnrichedVulnerability | undefined;
// eslint-disable-next-line no-redeclare
export function parseEnrichment(
  vuln?: Vulnerability
): EnrichedVulnerability | undefined {
  if (!vuln) return undefined;
  if (!vuln.data) return vuln as EnrichedVulnerability;

  try {
    const parsed = JSON.parse(vuln.data);
    return { ...vuln, ...parsed } as EnrichedVulnerability;
  } catch {
    return vuln as EnrichedVulnerability;
  }
}
